/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_PurrInputs */

const fr_rapid_eager_otter_purr = /** @type {(inputs: Rapid_Eager_Otter_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`années`)
};

/**

* @param {Rapid_Eager_Otter_PurrInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_purr = /** @type {((inputs?: Rapid_Eager_Otter_PurrInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_PurrInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_purr(inputs)
});